<template>
  <div class="list addMerchant" name="add">
    <el-card shadow="never">
      <div class="step-view">
        <el-steps :active="stepIndex" align-center>
          <el-step title="填写激活码"></el-step>
          <el-step title="创建门店管理员"></el-step>
          <el-step title="填写门店信息"></el-step>
          <el-step title="设置费率"></el-step>
          <el-step title="完成"></el-step>
        </el-steps>
      </div>
    </el-card>
    <activationCode v-if="stepIndex === 1" @handlerCode="handlerCode"/>
    <createStoreManage v-if="stepIndex === 2" :activeCode="activeCode" @handlerSuccess="handlerSuccess"/>
    <infoForm :isChain="isChain" :chainShopId="chainShopId" v-if="stepIndex === 3" :isEdit="false"  @submit="submitInfo" submit-text="下一步" :submit-loading="submitLoading" :stepIndex="stepIndex"></infoForm>
    <rateForm :isChain="isChain" v-if="stepIndex === 4" :id="FMerchantId" @submit="submitRate" style="margin: 20px 0;" :is-add="true"></rateForm>
  </div>
</template>

<script>
import infoForm from '../components/infoForm2'
import rateForm from '../components/rateForm'
import activationCode from './components/activation-code'
import createStoreManage from './components/create-store-manage'
import { intellectRegister, checkMerchantStatus } from '@/api/merchant'
import { chainShopRelativeMerchant } from '@/api/merchant-info'
import qs from 'qs'
import md5 from 'js-md5'
export default {
  name: 'AddMerchant',
  components: {
    infoForm,
    rateForm,
    activationCode,
    createStoreManage
  },
  data () {
    return {
      mobile: '',
      chainShopId: '',
      activeCode: '',
      isChain: true, // 是否连锁商户
      stepIndex: 1,
      submitLoading: false,
      originPsd: '', // 原本的密码
      FMerchantId: ''// 商户id
    }
  },
  provide () {
    return {
      isChain: this.isChain
    }
  },
  mounted () {
    // this.FMerchantId = '0913117154'
    // this.checkResult()
    if (this.$route.query.step) {
      this.stepIndex = this.$route.query.step || 1
    }
  },
  methods: {

    // 与总店保持一致直接完成
    handlerUpdate () {
      this.stepIndex = 5
    },
    handlerCode (activeCode) {
      this.stepIndex = 2
      this.activeCode = activeCode
    },
    handlerSuccess (val) {
      this.stepIndex = 3
      this.shopId = val.shopId
      this.chainShopId = val.shopId
      this.mobile = val.mobile
    },
    async chainShopRelativeMerchant (merchantId) {
      try {
        await chainShopRelativeMerchant({
          chainMerchantId: merchantId,
          chainShopId: this.shopId
        })
      } catch (e) {
        console.log(e)
      }
    },
    /**
       * @description 提交基本信息表单
       * @param {Object} data整个表单数据
       */
    submitInfo (data) {
      const that = this
      that.$confirm('确认提交吗？', '提示', {}).then(() => {
        var pw = data.userPassword
        this.originPsd = data.userPassword
        // 手机号码
        data.mobile = this.mobile
        that.submitLoading = true
        for (const key in data) {
          // eslint-disable-next-line no-prototype-builtins
          if (data.hasOwnProperty(key) && !['legalName', 'holder'].includes(key)) {
            const element = data[key]
            if (typeof element === 'string') {
              data[key] = element.replace(/ /g, '')
            }
          }
        }
        let para = Object.assign({}, this.dismissBlank(data))
        para = JSON.parse(JSON.stringify(para))
        if (pw) { para.userPassword = md5(pw) }
        para = qs.stringify(para)
        intellectRegister(para).then(async res => {
          that.submitLoading = false
          if (res.result_cde === '0') {
            that.FMerchantId = res.data.merchantId
            that.stepIndex = 4
            await this.chainShopRelativeMerchant(res.data.merchantId)
            that.$message({
              message: res.result_msg,
              type: 'success'
            })
          } else {
            that.$message({
              showClose: true,
              message: res.result_msg,
              type: 'error'
            })
          }
        })
      })
    },
    submitRate (result) {
      if (result) {
        this.stepIndex = 5
        this.$message({
          message: '设置成功，已提交审核'
        })
        this.checkResult()
      }
    },
    /**
       * 删除对象中字符串的空格
       */
    dismissBlank (params) {
      for (const key in params) {
        // eslint-disable-next-line no-prototype-builtins
        if (params.hasOwnProperty(key)) {
          const element = params[key]
          if (typeof element === 'string' && !['legalName', 'holder'].includes(key)) {
            params[key] = element.replace(/ /g, '')
          }
        }
      }
      return params
    },
    // 查询审核结果
    checkResult () {
      const data = qs.stringify({
        merchantId: this.FMerchantId
      })
      checkMerchantStatus(data).then(response => {
        if (parseInt(response.result_cde) === 0) {
          const code = response.data.code// 审核通过，资料审核中
          let icon, type, errorMsg, btnText, text
          switch (code) {
            case 1: {
              text = '审核不通过'
              icon = 'el-icon-warning'
              type = 'failed'
              errorMsg = response.data.desc
              btnText = '修改商户资料'
              break
            }
            case 0:
            case 2:
            {
              text = '审核中'
              icon = 'el-icon-loading'
              type = 'waiting'
              errorMsg = '预计30min完成审核，关注公众号即可实时接收审核结果通知'
              btnText = '再次进件'
              break
            }
            case 3: {
              text = '审核通过'
              icon = 'el-icon-success'
              type = 'success'
              errorMsg = '恭喜你，商户已审核通过！马上进行交易吧'
              btnText = '再次进件'
              break
            }
            case -1: {
              text = '资料待完善'
              icon = 'el-icon-loading'
              type = 'waiting'
              errorMsg = '请继续完善资料才可提交审核哦'
              btnText = '继续完善'
              break
            }
            default: {
              text = '状态异常'
              icon = 'el-icon-loading'
              type = 'waiting'
              errorMsg = '请到所有商户列表查看内容'
              btnText = '再次进件'
            }
          }

          this.$confirm('<div class="result">' +
              '<div class="' + type + '">' +
              '<i class="' + icon + '"></i>' +
              '<p class="resultTitle">' + text + '</p>' +
              '</div><p class="desc">' + errorMsg + '</p></div>', '', {
            confirmButtonText: btnText,
            cancelButtonText: '我知道了',
            center: true,
            closeOnClickModal: false,
            dangerouslyUseHTMLString: true
          }).then(() => {
            if (code === 1 || code === -1) {
              //    跳转到查看修改页面
              const query = {
                id: this.FMerchantId,
                readOnly: '0',
                isEdit: '1'
              }
              this.$router.push({
                path: '/Merchant/details',
                query: query
              })
            } else {
              this.stepIndex = 1
            }
          }).catch(() => {
            this.stepIndex = 1
          })
        } else {
          this.$message({
            message: response.result_msg,
            type: 'error'
          })
          this.stepIndex = 1
        }
      })
    }
  }
}
</script>

<style scoped>
  .addMerchant{
    background: #fff;
    padding:20px 0 20px 0;
    margin:0 16px 16px 16px;
  }

</style>
<style>
  .result{
    margin-bottom: 16px;
    text-align: center;
  }
  .result i{
    font-size: 40px;
  }
  .result .resultTitle{
    font-size: 15px;
    font-weight: bold;
  }
  .result .success{
    color: #67C23A;
  }
  .result .failed{
    color: #F56C6C;
  }
  .result .waiting{
    color: #909399;
  }
  .result .desc{
    color: #909399;
    font-size: 13px;
  }
</style>
